import GenericError from './generic-error'

export default class AuthenticationError extends GenericError {
  constructor (code = 401, response = {}, ...params) {
    super(code, response, ...params)
  }
}



// WEBPACK FOOTER //
// ./src/services/error/authentication-error.js